window.addEventListener('DOMContentLoaded', () => {
    const mediaList = document.querySelector("body .product__media-list");
    const mediaItems = mediaList.querySelectorAll(".product__media-item");
    if(mediaItems.length > 6) {
        for(let i = 6; i < mediaItems.length; i ++) {
            mediaItems[i].style.display = "none";
        }

        const viewMoreBtn = document.createElement("div");
        viewMoreBtn.innerHTML = `
            <p>mehr anzeigen</p>
            <svg xmlns="http://www.w3.org/2000/svg" width="16" height="11" viewBox="0 0 16 11" fill="none">
                <path d="M15.8169 8.78653e-07L15.8169 3.0395L7.90847 10.6383L7.90847 7.59875L15.8169 8.78653e-07Z" fill="#1B1B19"/>
                <path d="M3.94665e-05 8.78653e-07L3.93635e-05 3.0395L7.90851 10.6383L7.90851 7.59875L3.94665e-05 8.78653e-07Z" fill="#1B1B19"/>
            </svg>
        `;
        viewMoreBtn.classList.add("product-view-more");
        viewMoreBtn.setAttribute("onclick", "viewmore()");
        mediaList.parentElement.append(viewMoreBtn);
    }
})

const viewmore = () => {
    const mediaItems = document.querySelectorAll(".product__media-item");
    const viewMoreBtn = document.querySelector(".product-view-more");

    for(let i = 6; i < mediaItems.length; i ++) {
        mediaItems[i].style.display = "block";
    }
    viewMoreBtn.style.display = "none";
}